/* ==========================================================================
   Veyron BOGO widget - portado do tema publicado (Horizon) para este tema.

   Mudancas necessarias em relacao ao original:
   - Removido o import de '@shopify/events' (CartLinesUpdateEvent), que so
     existe no Horizon. Aqui o carrinho e atualizado pelo <vey-cart-drawer>.
   - Trocado o global Theme.routes por window.Shopify.routes.root.
   - Trocado o seletor .buy-buttons-block pelo bloco de compra deste tema.
   A logica de selecao, modal e estados foi preservada.
   ========================================================================== */
(function () {
  'use strict';

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  class VeyronBogo extends HTMLElement {
    connectedCallback() {
      this.mainVariantId = this.dataset.mainVariantId;
      this.defaultCompareFormatted = this.dataset.defaultCompare || '';
      this.selectLabel = this.dataset.selectLabel || 'Select';
      this.removeLabel = this.dataset.removeLabel || 'Remove';
      this.chooseLabel = this.dataset.chooseLabel || 'Choose Another Watch';
      this.changeLabelText = this.dataset.changeLabelText || 'Change';

      this.giftVariantId = this.mainVariantId;

      this.modal = this.querySelector('[data-modal]');
      this.buy1Btn = this.querySelector('[data-bogo-mode-button="single"]');
      this.bogoCard = this.querySelector('[data-bogo-card]');
      this.bogoModeBtn = this.querySelector('[data-bogo-mode-button="bogo"]');
      this.openModalBtns = this.querySelectorAll('[data-open-modal]');
      this.closeModalBtn = this.querySelector('[data-close-modal]');
      this.giftRow = this.querySelector('[data-gift-row]');
      this.giftImage = this.querySelector('[data-gift-image]');
      this.giftTitleEl = this.querySelector('[data-gift-title]');
      this.bogoCompareEl = this.querySelector('[data-bogo-compare]');
      this.selectedCountEl = this.querySelector('[data-selected-count]');
      this.atcBtn = this.querySelector('[data-bogo-add-to-cart]');
      this.iconPlus = this.querySelector('.veyron-bogo__icon-plus');
      this.iconSwap = this.querySelector('.veyron-bogo__icon-swap');
      this.changeLabelEl = this.querySelector('[data-change-label]');

      this.defaultGiftImageHTML = this.giftImage ? this.giftImage.innerHTML : '';
      this.defaultGiftTitle = this.giftTitleEl ? this.giftTitleEl.textContent.trim() : '';

      // Botao de compra padrao deste tema (escondido no modo BOGO).
      this.nativeBuyButtons = document.querySelector('[data-native-buy]');

      if (this.buy1Btn) this.buy1Btn.addEventListener('click', () => this.setMode('single'));
      if (this.bogoModeBtn) this.bogoModeBtn.addEventListener('click', () => this.setMode('bogo'));
      this.openModalBtns.forEach((btn) => btn.addEventListener('click', () => this.openModal()));
      if (this.closeModalBtn) this.closeModalBtn.addEventListener('click', () => this.closeModal());
      if (this.modal) {
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.closeModal();
        });
      }
      this.querySelectorAll('[data-gift-card]').forEach((card) => {
        const btn = card.querySelector('[data-select-gift]');
        if (btn) btn.addEventListener('click', () => this.toggleGift(card));
      });
      if (this.atcBtn) this.atcBtn.addEventListener('click', () => this.addBogoToCart());

      this.setMode('bogo');
    }

    setMode(mode) {
      this.mode = mode;
      this.classList.toggle('veyron-bogo--bogo-active', mode === 'bogo');

      const buy1Radio = this.buy1Btn ? this.buy1Btn.querySelector('[data-radio]') : null;
      const bogoRadio = this.bogoModeBtn ? this.bogoModeBtn.querySelector('[data-radio]') : null;
      if (buy1Radio) buy1Radio.classList.toggle('is-checked', mode === 'single');
      if (bogoRadio) bogoRadio.classList.toggle('is-checked', mode === 'bogo');
      if (this.bogoCard) this.bogoCard.classList.toggle('veyron-bogo__option--selected', mode === 'bogo');

      if (this.nativeBuyButtons) {
        this.nativeBuyButtons.style.display = mode === 'bogo' ? 'none' : '';
      }
    }

    openModal() {
      if (this.modal && typeof this.modal.showModal === 'function') this.modal.showModal();
    }

    closeModal() {
      if (this.modal && typeof this.modal.close === 'function') this.modal.close();
    }

    toggleGift(card) {
      const alreadySelected = card.classList.contains('is-selected');

      this.querySelectorAll('[data-gift-card]').forEach((c) => {
        c.classList.remove('is-selected');
        const label = c.querySelector('[data-select-label]');
        const btn = c.querySelector('[data-select-gift]');
        if (label) label.textContent = this.selectLabel;
        if (btn) btn.classList.remove('is-remove');
      });

      if (!alreadySelected) {
        card.classList.add('is-selected');
        const label = card.querySelector('[data-select-label]');
        const btn = card.querySelector('[data-select-gift]');
        if (label) label.textContent = this.removeLabel;
        if (btn) btn.classList.add('is-remove');

        this.giftVariantId = card.dataset.variantId;
        const title = card.dataset.title || '';
        const image = card.dataset.image || '';

        if (this.giftImage) {
          this.giftImage.innerHTML = '';
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = title;
            img.loading = 'lazy';
            img.width = 50;
            img.height = 50;
            this.giftImage.appendChild(img);
          }
        }
        if (this.giftTitleEl) this.giftTitleEl.textContent = title;
        if (this.giftRow) this.giftRow.hidden = false;
        if (this.iconPlus) this.iconPlus.hidden = true;
        if (this.iconSwap) this.iconSwap.hidden = false;
        if (this.changeLabelEl) this.changeLabelEl.textContent = this.changeLabelText;
        if (this.selectedCountEl) this.selectedCountEl.textContent = '1';
        if (this.bogoCompareEl) this.bogoCompareEl.textContent = card.dataset.compareTotal;
        this.closeModal();
      } else {
        this.resetGiftToDefault();
        if (this.selectedCountEl) this.selectedCountEl.textContent = '0';
      }
    }

    resetGiftToDefault() {
      this.giftVariantId = this.mainVariantId;
      if (this.giftImage) this.giftImage.innerHTML = this.defaultGiftImageHTML;
      if (this.giftTitleEl) this.giftTitleEl.textContent = this.defaultGiftTitle;
      if (this.giftRow) this.giftRow.hidden = true;
      if (this.iconPlus) this.iconPlus.hidden = false;
      if (this.iconSwap) this.iconSwap.hidden = true;
      if (this.changeLabelEl) this.changeLabelEl.textContent = this.chooseLabel;
      if (this.bogoCompareEl) this.bogoCompareEl.textContent = this.defaultCompareFormatted;
    }

    async addBogoToCart() {
      if (!this.atcBtn) return;
      this.atcBtn.disabled = true;

      try {
        const res = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(this.mainVariantId), quantity: 1 },
              { id: Number(this.giftVariantId), quantity: 1 }
            ]
          })
        });

        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Failed to add BOGO items to cart');
        }

        // Atualiza e abre o carrinho lateral deste tema.
        const drawer = document.querySelector('vey-cart-drawer');
        if (drawer && typeof drawer.refresh === 'function') {
          await drawer.refresh();
          drawer.open();
        } else {
          window.location.href = cartUrl('cart');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.atcBtn.disabled = false;
      }
    }
  }

  if (!customElements.get('veyron-bogo')) {
    customElements.define('veyron-bogo', VeyronBogo);
  }
})();
